
const NS = 'AppEventService'; // jshint ignore:line

export default function AppEventService() {
  "ngInject";

  var listeners = [];

  var service = {
    emit: emit,
    on: on,
    off: off
  };

  return service;

  function emit(type, evt, targetEvt) {
    for (var listener of listeners) {
      if (listener.type === type) {
        listener.func(evt, targetEvt);
      }
    }
  }

  function on(type, func) {
    var id = Math.random() + type;

    listeners.push({
      id: id,
      type: type,
      func: func
    });

    return id;
  }

  function off(id) {
    var index = listeners.findIndex(listener => listener.id === id);
    if (index > -1) {
      listeners.splice(index, 1);
    }
  }
}
